(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psxc-1nmr2-2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function slider(el){
    var t=el.querySelector('[data-psxc-track]'); if(!t||t.dataset.ready) return; t.dataset.ready='1';
    function step(){var c=t.children[0];return c?c.getBoundingClientRect().width:t.clientWidth}
    function go(d){var max=t.scrollWidth-t.clientWidth-2;if(d>0&&t.scrollLeft>=max)t.scrollTo({left:0});else if(d<0&&t.scrollLeft<=0)t.scrollTo({left:max});else t.scrollBy({left:d*step()})}
    el.querySelectorAll('[data-psxc-prev]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(-1)})});
    el.querySelectorAll('[data-psxc-next]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(1)})});
  }
  function tabs(root){
    root.querySelectorAll('[role=tab][aria-controls]').forEach(function(tab){
      if(tab.dataset.ready) return; tab.dataset.ready='1';
      tab.addEventListener('click',function(e){
        e.preventDefault(); var list=tab.closest('[role=tablist]')||tab.parentElement;
        var tc=list.getAttribute('data-psxc-tabc'), pc=list.getAttribute('data-psxc-panc');
        list.querySelectorAll('[role=tab]').forEach(function(t){var on=t===tab;t.setAttribute('aria-selected',on);if(tc)t.classList.toggle(tc,on);var p=document.getElementById(t.getAttribute('aria-controls'));if(p){p.hidden=!on;if(pc)p.classList.toggle(pc,on)}});
      });
    });
  }
  function acc(root){
    root.querySelectorAll('[aria-expanded][aria-controls]:not([role=tab])').forEach(function(b){
      if(b.dataset.ready) return; b.dataset.ready='1';
      b.addEventListener('click',function(e){
        var p=document.getElementById(b.getAttribute('aria-controls')); if(!p) return; e.preventDefault();
        var open=b.getAttribute('aria-expanded')!=='true'; b.setAttribute('aria-expanded',open); p.hidden=!open;
        if(open){p.style.maxHeight='none';p.style.height='auto';p.style.visibility='visible';p.style.opacity='1'}
      });
    });
  }
  function cd(root){
    root.querySelectorAll('[data-psxc-cd]').forEach(function(el){
      if(el.dataset.ready) return; el.dataset.ready='1';
      var end=new Date(String(el.getAttribute('data-psxc-cd')).trim().replace(' ','T')).getTime(); if(isNaN(end)) end=Date.now()+3*864e5;
      function pad(n){return String(n).padStart(2,'0')}
      function tick(){var s=Math.max(0,Math.floor((end-Date.now())/1000));var v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
        if(!el.querySelector('[data-psxc-u=d]')) v.h+=v.d*24;
        el.querySelectorAll('[data-psxc-u]').forEach(function(n){n.textContent=pad(v[n.getAttribute('data-psxc-u')])});}
      tick(); setInterval(tick,1000);
    });
  }
  function init(r){ (r.querySelectorAll?r:document).querySelectorAll('[data-psxc-slider]').forEach(slider); tabs(r); acc(r); cd(r); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document)}); else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psxc-1nmr2-8"] && !Shopify.designMode) return;
  try {
    
(function(){
  function slider(el){
    var t=el.querySelector('[data-psxc-track]'); if(!t||t.dataset.ready) return; t.dataset.ready='1';
    function step(){var c=t.children[0];return c?c.getBoundingClientRect().width:t.clientWidth}
    function go(d){var max=t.scrollWidth-t.clientWidth-2;if(d>0&&t.scrollLeft>=max)t.scrollTo({left:0});else if(d<0&&t.scrollLeft<=0)t.scrollTo({left:max});else t.scrollBy({left:d*step()})}
    el.querySelectorAll('[data-psxc-prev]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(-1)})});
    el.querySelectorAll('[data-psxc-next]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(1)})});
  }
  function tabs(root){
    root.querySelectorAll('[role=tab][aria-controls]').forEach(function(tab){
      if(tab.dataset.ready) return; tab.dataset.ready='1';
      tab.addEventListener('click',function(e){
        e.preventDefault(); var list=tab.closest('[role=tablist]')||tab.parentElement;
        var tc=list.getAttribute('data-psxc-tabc'), pc=list.getAttribute('data-psxc-panc');
        list.querySelectorAll('[role=tab]').forEach(function(t){var on=t===tab;t.setAttribute('aria-selected',on);if(tc)t.classList.toggle(tc,on);var p=document.getElementById(t.getAttribute('aria-controls'));if(p){p.hidden=!on;if(pc)p.classList.toggle(pc,on)}});
      });
    });
  }
  function acc(root){
    root.querySelectorAll('[aria-expanded][aria-controls]:not([role=tab])').forEach(function(b){
      if(b.dataset.ready) return; b.dataset.ready='1';
      b.addEventListener('click',function(e){
        var p=document.getElementById(b.getAttribute('aria-controls')); if(!p) return; e.preventDefault();
        var open=b.getAttribute('aria-expanded')!=='true'; b.setAttribute('aria-expanded',open); p.hidden=!open;
        if(open){p.style.maxHeight='none';p.style.height='auto';p.style.visibility='visible';p.style.opacity='1'}
      });
    });
  }
  function cd(root){
    root.querySelectorAll('[data-psxc-cd]').forEach(function(el){
      if(el.dataset.ready) return; el.dataset.ready='1';
      var end=new Date(String(el.getAttribute('data-psxc-cd')).trim().replace(' ','T')).getTime(); if(isNaN(end)) end=Date.now()+3*864e5;
      function pad(n){return String(n).padStart(2,'0')}
      function tick(){var s=Math.max(0,Math.floor((end-Date.now())/1000));var v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
        if(!el.querySelector('[data-psxc-u=d]')) v.h+=v.d*24;
        el.querySelectorAll('[data-psxc-u]').forEach(function(n){n.textContent=pad(v[n.getAttribute('data-psxc-u')])});}
      tick(); setInterval(tick,1000);
    });
  }
  function init(r){ (r.querySelectorAll?r:document).querySelectorAll('[data-psxc-slider]').forEach(slider); tabs(r); acc(r); cd(r); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document)}); else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
